import { call } from 'redux-saga/effects';

import { getInDomain } from '../../../domains/externalUtils';
import { putAndWait } from '../../../sagas/TaskManager';
import Logger from '../../../tools/Logger';

const log = Logger.child({ component: 'mediator/useCases/skipTrackForward' });

export function* handleSkippingAudioAd({ payload: { sourceId, skipType } }) {
  log.info('handleSkippingAudioAd(): attempting to play next ad or the next track in station');
  yield call(
    putAndWait,
    getInDomain('playback.actions.playTrackFromStation')({
      id: sourceId,
      userInitiatedSkip: true,
      next: true,
      skipType,
    }),
  );
}
